<div class="capital-trade puppet">
  <div class="row">
    <div class="col-xs-12 puppet__search-box">
      <label class="title-name puppet__search-box-label">
        Emisora
        <span *ngIf="isUsaContract" class="puppet__search-box-icon">
          <img
            alt="Información"
            src="images/atm-icn-help-info.svg"
            (mouseover)="showSearchTooltip = true"
            (mouseleave)="showSearchTooltip = false"
          />

          <hb-tooltip-component
            *ngIf="showSearchTooltip"
            text="Información retrasada por 15 min"
            relativePosition="top"
            [width]="248"
            [isLarge]="true"
          >
          </hb-tooltip-component>
        </span>
      </label>

      <hb-search-box
        [placeholder]="
          isUsaContract ? 'Buscar emisoras' : 'Buscar nacional y SIC'
        "
        [isUsaContract]="isUsaContract"
        [propertyForDisplayedPrice]="usaOperation"
      ></hb-search-box>
    </div>
  </div>

  <div class="operation-switch" *ngIf="isUsaContract">
    <button
      class="operation-switch--buy"
      [ngClass]="{ active: usaOperation === capitalOperations.buy }"
      (click)="setUsaOperation(capitalOperations.buy)"
    >
      Comprar
    </button>
    <button
      class="operation-switch--sell"
      [ngClass]="{ active: usaOperation === capitalOperations.sell }"
      (click)="setUsaOperation(capitalOperations.sell)"
    >
      Vender
    </button>
  </div>

  <div
    class="row fix-margin scrollable-div"
    [class.scrolling-set]="scrolledSet === true"
    [ngStyle]="{ 'max-height': scrollableHeight }"
    *ngIf="operations"
    [ngClass]="selectedOrderClass"
  >
    <h6 class="position-title">Posición en portafolio</h6>
    <div class="position-container">
      <div class="left-side">
        <div class="row">
          <div class="left-side">
            <span class="label">Títulos</span>
          </div>
          <div class="right-side end-xs">
            <span class="label bold" *ngIf="!shouldDisplayIssueData">
              {{ missingInformationText }}
            </span>
            <span
              *ngIf="shouldDisplayIssueData"
              class="label bold"
              data-recording-sensitive
              >{{
                position.shares
                  | hbCustomFormat: (isUsaContract ? '0,0.00000000' : '0,0')
              }}</span
            >
          </div>
        </div>
        <div class="row">
          <div class="left-side">
            <span class="label">Plus/Minus</span>
          </div>
          <div class="right-side end-xs">
            <span class="label bold" *ngIf="!shouldDisplayIssueData">
              {{ missingInformationText }}
            </span>
            <span
              class="label bold"
              *ngIf="shouldDisplayIssueData"
              [class.neutro]="position.var === 0"
              [class.positive]="position.var > 0"
              [class.negative]="position.var < 0"
              data-recording-sensitive
            >
              {{
                position.plusMinus
                  | hbCustomFormat
                    : (position.plusMinus > 0 && position.plusMinus < 1
                        ? '$0,0[.]00[0]'
                        : '$0,0[.]00')
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="right-side just-size">
        <div class="row end-xs">
          <div class="left-side start-xs">
            <span class="label">{{
              isUsaContract ? 'Monto' : 'Costo prom.'
            }}</span>
          </div>
          <div class="right-side end-xs">
            <span *ngIf="!shouldDisplayIssueData" class="label bold">
              {{ missingInformationText }}
            </span>
            <span
              *ngIf="shouldDisplayIssueData"
              class="label bold"
              data-recording-sensitive
            >
              {{
                isUsaContract
                  ? (position.marketValue
                    | hbCustomFormat
                      : (position.marketValue < 1 ? '$0,0[.]000' : '$0,0[.]00'))
                  : (position.ctoProm
                    | hbCustomFormat
                      : (position.ctoProm < 1 ? '$0,0[.]000' : '$0,0[.]00'))
              }}
            </span>
          </div>
        </div>
        <div class="row end-xs">
          <div class="left-side start-xs">
            <span class="label">% Var hist.</span>
          </div>
          <div class="right-side end-xs">
            <span class="label bold" *ngIf="!shouldDisplayIssueData">
              {{ missingInformationText }}
            </span>
            <span
              class="label bold"
              *ngIf="shouldDisplayIssueData"
              [class.neutro]="position.var === 0"
              [class.positive]="position.var > 0"
              [class.negative]="position.var < 0"
              data-recording-sensitive
              >{{ position.var | hbCustomFormat: '0[.]00%' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <hb-usa-order
      *ngIf="isUsaContract"
      [operation]="usaOperation"
    ></hb-usa-order>

    <hb-posturas
      *ngIf="!isUsaContract"
      (emitPrice)="setCopiedPrice($event)"
      [currentIssue]="currentIssue"
      [posturasList]="level2"
      [hasLevel]="userInfo.hasLevel2"
      [hasIssue]="userHasIssue"
    >
    </hb-posturas>

    <div class="orden-container" *ngIf="operations && !isUsaContract">
      <h6 class="makeorder-title">Realizar orden</h6>
      <label class="title-name">Tipo de orden</label>
      <div class="order-list">
        <combo-select
          class="combo-shadow"
          *ngIf="lockSelectCombo === false"
          [sentSelected]="selectedOrder"
          [resultsList]="ordenType"
          [title]="'Tipo de orden'"
          (emitSelectedItem)="setOrderType($event)"
        >
        </combo-select>
      </div>

      <limitada-order
        [isUserGlobal]="isUserGlobal"
        [userRole]="userRole"
        [isInternalUser]="isInternalUser"
        [hasIssue]="userHasIssue"
        [isReadAndWrite]="true"
        [currentIssue]="currentIssue"
        [currentContract]="currentContract"
        [selectedPrice]="selectedPrice"
        [replaceTitles]="replaceTitles"
        [mfaType]="userInfo.mfaType"
        [readToken]="userInfo.readToken"
        [elPatronData]="elPatronData"
        *ngIf="selectedOrder.id == 1"
        [isDiscretional]="isDiscretional"
        [isGeolocationEnabled]="isGeolocationEnabled"
        [shouldNotifyGeolocationOnOperationAttempt]="
          shouldNotifyGeolocationOnOperationAttempt
        "
        [shouldStartLoaderOnOperationAttempt]="
          shouldStartLoaderOnOperationAttempt
        "
        [isPositionMocked]="isPositionMocked"
      >
      </limitada-order>
      <enlinea-order
        [isUserGlobal]="isUserGlobal"
        [userRole]="userRole"
        [isInternalUser]="isInternalUser"
        [hasIssue]="userHasIssue"
        [isReadAndWrite]="true"
        [currentIssue]="currentIssue"
        [currentContract]="currentContract"
        [replaceTitles]="replaceTitles"
        [mfaType]="userInfo.mfaType"
        [readToken]="userInfo.readToken"
        [elPatronData]="elPatronData"
        *ngIf="selectedOrder.id == 2"
        [isDiscretional]="isDiscretional"
        [isGeolocationEnabled]="isGeolocationEnabled"
        [shouldNotifyGeolocationOnOperationAttempt]="
          shouldNotifyGeolocationOnOperationAttempt
        "
        [shouldStartLoaderOnOperationAttempt]="
          shouldStartLoaderOnOperationAttempt
        "
        [isPositionMocked]="isPositionMocked"
      >
      </enlinea-order>
      <mplactiva-order
        [userRole]="userRole"
        [isInternalUser]="isInternalUser"
        [hasIssue]="userHasIssue"
        [isReadAndWrite]="true"
        [currentIssue]="currentIssue"
        [currentContract]="currentContract"
        [selectedPrice]="selectedPrice"
        [replaceTitles]="replaceTitles"
        [mfaType]="userInfo.mfaType"
        [readToken]="userInfo.readToken"
        [elPatronData]="elPatronData"
        *ngIf="selectedOrder.id == 3"
        [isDiscretional]="isDiscretional"
        [isGeolocationEnabled]="isGeolocationEnabled"
        [shouldNotifyGeolocationOnOperationAttempt]="
          shouldNotifyGeolocationOnOperationAttempt
        "
        [shouldStartLoaderOnOperationAttempt]="
          shouldStartLoaderOnOperationAttempt
        "
        [isPositionMocked]="isPositionMocked"
      >
      </mplactiva-order>
      <mplpasiva-order
        [userRole]="userRole"
        [isInternalUser]="isInternalUser"
        [hasIssue]="userHasIssue"
        [isReadAndWrite]="true"
        [currentIssue]="currentIssue"
        [currentContract]="currentContract"
        [selectedPrice]="selectedPrice"
        [replaceTitles]="replaceTitles"
        [mfaType]="userInfo.mfaType"
        [readToken]="userInfo.readToken"
        [elPatronData]="elPatronData"
        *ngIf="selectedOrder.id == 4"
        [isDiscretional]="isDiscretional"
        [isGeolocationEnabled]="isGeolocationEnabled"
        [shouldNotifyGeolocationOnOperationAttempt]="
          shouldNotifyGeolocationOnOperationAttempt
        "
        [shouldStartLoaderOnOperationAttempt]="
          shouldStartLoaderOnOperationAttempt
        "
        [isPositionMocked]="isPositionMocked"
      >
      </mplpasiva-order>
      <mplvolumenoculto-order
        [userRole]="userRole"
        [isInternalUser]="isInternalUser"
        [hasIssue]="userHasIssue"
        [isReadAndWrite]="true"
        [currentIssue]="currentIssue"
        [currentContract]="currentContract"
        [selectedPrice]="selectedPrice"
        [replaceTitles]="replaceTitles"
        [mfaType]="userInfo.mfaType"
        [readToken]="userInfo.readToken"
        [elPatronData]="elPatronData"
        *ngIf="selectedOrder.id == 5"
        [isDiscretional]="isDiscretional"
        [isGeolocationEnabled]="isGeolocationEnabled"
        [shouldNotifyGeolocationOnOperationAttempt]="
          shouldNotifyGeolocationOnOperationAttempt
        "
        [shouldStartLoaderOnOperationAttempt]="
          shouldStartLoaderOnOperationAttempt
        "
        [isPositionMocked]="isPositionMocked"
      >
      </mplvolumenoculto-order>
      <onecancelanother-order
        [isUserGlobal]="isUserGlobal"
        [userRole]="userRole"
        [isInternalUser]="isInternalUser"
        [hasIssue]="userHasIssue"
        [isReadAndWrite]="true"
        [currentIssue]="currentIssue"
        [currentContract]="currentContract"
        [selectedPrice]="selectedPrice"
        [replaceTitles]="replaceTitles"
        [mfaType]="userInfo.mfaType"
        [readToken]="userInfo.readToken"
        [elPatronData]="elPatronData"
        *ngIf="selectedOrder.id == 6"
        [isDiscretional]="isDiscretional"
        [isGeolocationEnabled]="isGeolocationEnabled"
        [shouldNotifyGeolocationOnOperationAttempt]="
          shouldNotifyGeolocationOnOperationAttempt
        "
        [shouldStartLoaderOnOperationAttempt]="
          shouldStartLoaderOnOperationAttempt
        "
        [isPositionMocked]="isPositionMocked"
      >
      </onecancelanother-order>
      <onetriggersanother-order
        [isUserGlobal]="isUserGlobal"
        [userRole]="userRole"
        [isInternalUser]="isInternalUser"
        [hasIssue]="userHasIssue"
        [isReadAndWrite]="true"
        [currentIssue]="currentIssue"
        [currentContract]="currentContract"
        [selectedPrice]="selectedPrice"
        [replaceTitles]="replaceTitles"
        [mfaType]="userInfo.mfaType"
        [readToken]="userInfo.readToken"
        [elPatronData]="elPatronData"
        *ngIf="selectedOrder.id == 7"
        [isDiscretional]="isDiscretional"
        [isGeolocationEnabled]="isGeolocationEnabled"
        [shouldNotifyGeolocationOnOperationAttempt]="
          shouldNotifyGeolocationOnOperationAttempt
        "
        [shouldStartLoaderOnOperationAttempt]="
          shouldStartLoaderOnOperationAttempt
        "
        [isPositionMocked]="isPositionMocked"
      >
      </onetriggersanother-order>
      <stopenlinea-order
        [isUserGlobal]="isUserGlobal"
        [userRole]="userRole"
        [isInternalUser]="isInternalUser"
        [hasIssue]="userHasIssue"
        [isReadAndWrite]="true"
        [currentIssue]="currentIssue"
        [currentContract]="currentContract"
        [selectedPrice]="selectedPrice"
        [replaceTitles]="replaceTitles"
        [mfaType]="userInfo.mfaType"
        [readToken]="userInfo.readToken"
        [elPatronData]="elPatronData"
        *ngIf="selectedOrder.id == 8"
        [isDiscretional]="isDiscretional"
        [isGeolocationEnabled]="isGeolocationEnabled"
        [shouldNotifyGeolocationOnOperationAttempt]="
          shouldNotifyGeolocationOnOperationAttempt
        "
        [shouldStartLoaderOnOperationAttempt]="
          shouldStartLoaderOnOperationAttempt
        "
        [isPositionMocked]="isPositionMocked"
      >
      </stopenlinea-order>
      <stoplimitado-order
        [isUserGlobal]="isUserGlobal"
        [userRole]="userRole"
        [isInternalUser]="isInternalUser"
        [hasIssue]="userHasIssue"
        [isReadAndWrite]="true"
        [currentIssue]="currentIssue"
        [currentContract]="currentContract"
        [selectedPrice]="selectedPrice"
        [replaceTitles]="replaceTitles"
        [mfaType]="userInfo.mfaType"
        [readToken]="userInfo.readToken"
        [elPatronData]="elPatronData"
        *ngIf="selectedOrder.id == 9"
        [isDiscretional]="isDiscretional"
        [isGeolocationEnabled]="isGeolocationEnabled"
        [shouldNotifyGeolocationOnOperationAttempt]="
          shouldNotifyGeolocationOnOperationAttempt
        "
        [shouldStartLoaderOnOperationAttempt]="
          shouldStartLoaderOnOperationAttempt
        "
        [isPositionMocked]="isPositionMocked"
      >
      </stoplimitado-order>
      <trailingstop-order
        [isUserGlobal]="isUserGlobal"
        [userRole]="userRole"
        [isInternalUser]="isInternalUser"
        [hasIssue]="userHasIssue"
        [isReadAndWrite]="true"
        [currentIssue]="currentIssue"
        [currentContract]="currentContract"
        [replaceTitles]="replaceTitles"
        [mfaType]="userInfo.mfaType"
        [readToken]="userInfo.readToken"
        [elPatronData]="elPatronData"
        *ngIf="selectedOrder.id == 10"
        [isDiscretional]="isDiscretional"
        [isGeolocationEnabled]="isGeolocationEnabled"
        [shouldNotifyGeolocationOnOperationAttempt]="
          shouldNotifyGeolocationOnOperationAttempt
        "
        [shouldStartLoaderOnOperationAttempt]="
          shouldStartLoaderOnOperationAttempt
        "
        [isPositionMocked]="isPositionMocked"
      >
      </trailingstop-order>
      <ventaencorto-order
        [userRole]="userRole"
        [isInternalUser]="isInternalUser"
        [hasIssue]="userHasIssue"
        [isReadAndWrite]="true"
        [currentIssue]="currentIssue"
        [currentContract]="currentContract"
        [selectedPrice]="selectedPrice"
        [replaceTitles]="replaceTitles"
        [mfaType]="userInfo.mfaType"
        [readToken]="userInfo.readToken"
        [elPatronData]="elPatronData"
        *ngIf="selectedOrder.id == 11"
        [hasShortSellContract]="hasShortSellContract"
        [isDiscretional]="isDiscretional"
        [isGeolocationEnabled]="isGeolocationEnabled"
        [isPositionMocked]="isPositionMocked"
      >
      </ventaencorto-order>
    </div>
  </div>
</div>
